exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table_wrapper .th,\n.table_wrapper .td {\n  padding: 0.75rem;\n  vertical-align: middle;\n  font-size: 15px;\n  letter-spacing: 0.3px;\n  line-height: 35px;\n}\n.table_wrapper .th {\n  border-bottom: solid 1.5px #00A0E9;\n}\n.table_wrapper .th.top {\n  border-bottom: 0;\n  border-top: solid 1.5px #00A0E9;\n}\n.table_wrapper .th.no_border {\n  border-bottom: 0;\n}\n.table_wrapper .td {\n  font-weight: 300;\n  border-bottom: solid 1px #ced4da;\n}", ""]);

// exports
